import {useState} from "react";
import {ArrowIcon, Icon, QuestionContent, QuestionWrap, SummaryButton} from "./styled";

export const Question =  ({children,title})=>{
    const [open, setOpen] = useState(false);
    return (
        <QuestionWrap>
            <SummaryButton onClick={() => setOpen(!open)}>
                <Icon version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 32">
                    <path d="M12.571 22.429v4.286q0 0.286-0.214 0.5t-0.5 0.214h-4.286q-0.286 0-0.5-0.214t-0.214-0.5v-4.286q0-0.286 0.214-0.5t0.5-0.214h4.286q0.286 0 0.5 0.214t0.214 0.5zM18.214 11.714q0 0.964-0.277 1.804t-0.625 1.366-0.982 1.063-1.027 0.777-1.089 0.634q-0.732 0.411-1.223 1.161t-0.491 1.196q0 0.304-0.214 0.58t-0.5 0.277h-4.286q-0.268 0-0.455-0.33t-0.188-0.67v-0.804q0-1.482 1.161-2.795t2.554-1.938q1.054-0.482 1.5-1t0.446-1.357q0-0.75-0.83-1.321t-1.92-0.571q-1.161 0-1.929 0.518-0.625 0.446-1.911 2.054-0.232 0.286-0.554 0.286-0.214 0-0.446-0.143l-2.929-2.232q-0.232-0.179-0.277-0.446t0.098-0.5q2.857-4.75 8.286-4.75 1.429 0 2.875 0.554t2.607 1.482 1.893 2.277 0.732 2.83z"></path>
                </Icon>

                {title}

                <ArrowIcon $open={open} version="1.1" xmlns="http://www.w3.org/2000/svg" width="8" height="16"
                           viewBox="0 0 11 32">
                    <path
                        d="M10.625 17.143q0 0.232-0.179 0.411l-8.321 8.321q-0.179 0.179-0.411 0.179t-0.411-0.179l-0.893-0.893q-0.179-0.179-0.179-0.411t0.179-0.411l7.018-7.018-7.018-7.018q-0.179-0.179-0.179-0.411t0.179-0.411l0.893-0.893q0.179-0.179 0.411-0.179t0.411 0.179l8.321 8.321q0.179 0.179 0.179 0.411z"></path>
                </ArrowIcon>
            </SummaryButton>

            <QuestionContent $open={open}>
                {children}
            </QuestionContent>
        </QuestionWrap>
    )
}